
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { ERROR_INTERNO_SISTEMA } from '../constantes/constantes-errores';


@Injectable({
  providedIn: 'root'
})
export class UtilidadService { 

  constructor(private router: Router) { }


  public descargarArchivo(data: any, contentType: any, filename: any, extension: string): any {
    const blob = new Blob([data], { type: contentType + '; charset=utf-8' });
    saveAs(blob, filename + extension);
  }

  public toBase64(file: File | Blob, callback: any): any {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => callback(
      reader.result
    );
  }

  public fromBlobToHttpErrorResponse(file: File | Blob, callback: any): any {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onloadend = () => callback(
      reader.result
    );
  }

  onClickNavigate(ruta: string, parametros?:any): void {

    if(!parametros){
      this.router.navigate([ruta]);
    }else{
      this.router.navigate([ruta,parametros]);
    }
    
  }

  public procesarError(error:HttpErrorResponse):string{
    
    if(!error || !error.error || !error.error.message){
      return ERROR_INTERNO_SISTEMA;
    }

    return error.error.message;
  }

}
